import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVerlaatKoopwoning = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="m18 8 10 8v16H8V16"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M16 22h-6v10h6z"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M28.93 21.89v-2.63l5.99 5.98-5.99 5.98v-2.63H17.64v-6.7z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M26.19 27.74h-7.65v-1h8.65v4.39h-1zM20.94 8.01l3.062 2.45-.624.78-2.438-1.95-7.628 6.1-.624-.78z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVerlaatKoopwoning);

export default ForwardRef;
